import * as React from "react";
const VATStatementsView = React.lazy(() => import("./VATStatementsViewContainer"));

export { VATStatementsView };
